import React from "react";
import { avatar } from "../../assets";

const index = ({img, style}) => {
  return (
    <>
    <div className={`flex bg-gray-borderGray justify-center relative align-middle rounded-full overflow-hidden border-solid border-2 border-white md:border-solid md:border-4 md:border-[white] ${style ? style : 'w-[100px] h-[100px] md:h-[200px] md:w-[200px]'}`}>
        <div className='absolute '>
        <img className={`w-full ${!img && 'opacity-30'}` } src={img || avatar} alt="avatar" />
        </div>
      </div>
    </>
  );
};

export default index;
